import { render, staticRenderFns } from "./SettingsSection.vue?vue&type=template&id=6c816e19&"
import script from "./SettingsSection.vue?vue&type=script&lang=js&"
export * from "./SettingsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports